// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + {"18":"GsapScrollSmoother","225":"barba","435":"gsapScrollTrigger","979":"swiper"}[chunkId] + ".js";
};